var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyFiber(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1592 14.3671V16.8914C10.1592 18.2796 9.02322 19.4156 7.63494 19.4156H5.11065C3.72238 19.4156 2.58636 18.2796 2.58636 16.8914V14.3671C2.58636 12.9788 3.72238 11.8428 5.11065 11.8428H7.63494C9.02322 11.8428 10.1592 12.9788 10.1592 14.3671Z",
    fill: "black",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1589 5.10925V7.63354C10.1589 9.02181 9.02291 10.1578 7.63464 10.1578H5.11035C3.72207 10.1578 2.58606 9.02181 2.58606 7.63354V5.10925C2.58606 3.72097 3.72207 2.58496 5.11035 2.58496H7.63464C9.02291 2.58496 10.1589 3.72097 10.1589 5.10925Z",
    fill: "black",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4147 14.3671V16.8914C19.4147 18.2796 18.2787 19.4156 16.8904 19.4156H14.3661C12.9779 19.4156 11.8419 18.2796 11.8419 16.8914V14.3671C11.8419 12.9788 12.9779 11.8428 14.3661 11.8428H16.8904C18.2787 11.8428 19.4147 12.9788 19.4147 14.3671Z",
    fill: "black",
    fillOpacity: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4147 5.10925V7.63354C19.4147 9.02181 18.2787 10.1578 16.8904 10.1578H14.3661C12.9778 10.1578 11.8418 9.02181 11.8418 7.63354V5.10925C11.8418 3.72097 12.9778 2.58496 14.3661 2.58496H16.8904C18.2787 2.58496 19.4147 3.72097 19.4147 5.10925Z",
    fill: "black",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyFiber);
export default __webpack_public_path__ + "static/media/myFiber.46e6c76e3e81bd53a46bda2beabfaff6.svg";
export { ForwardRef as ReactComponent };